import React, { Component } from 'react';

class NenhumRegistroEncontrado extends Component {

     
    render() {
        
        var texto = '';

        switch (this.props.TipoPagina) {

            case 'novos':
                texto = 'Não existem novos eventos no momento.';
                break;

            case 'inscricoes-abertas':
                texto = 'Não existem eventos com inscrições abertas no momento.';
                break;
        }

        return (
                    <div className="full_width_inner">
                        <div className="vc_row wpb_row section vc_row-fluid  grid_section bg-white" style={{ backgroundColor: '#ffffff', borderTop: '1px solid rgb(238, 238, 238)', paddingTop: '87px', paddingBottom: '80px', textAlign: 'left' }}>
                            <div className=" section_inner clearfix">
                                <div className="section_inner_margin clearfix">
                                    <div className="wpb_column vc_column_container vc_col-sm-12">
                                        <div className="vc_column-inner">
                                            <div className="wpb_wrapper" style={{ marginBottom: 0 }}>
                                                <div className="wpb_text_column wpb_content_element ">
                                                    <div className="wpb_wrapper">
                                                        <h2 className="text-center">{texto}</h2>
                                                    </div>
                                                </div>
                                                <div className="separator small center"></div>
                                                <div className="separator transparent center"></div>
                                                <div className="itens-container">
                                                    <div className="q_circle_text_holder">
                                                        <center>
                                                            <a data-itemprop="url" className="icon_with_title_link" href="/concursos/encerrado" target="_self">Concursos encerrados</a>
                                                            <a data-itemprop="url" className="icon_with_title_link" href="/concursos/em-andamento" target="_self" style={{ marginLeft: '10px' }}>Concursos em andamento</a>
                                                        </center>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

        );
    }
}

export default NenhumRegistroEncontrado;